const FlagIcon = ({code, alt = code, size = 24, width = size, height = size, ...props}) => (
    <img
        {...props}
        alt={alt}
        width={width}
        height={height}
        src={`${main_theme_objects.theme_url}/public/build/img/flags/${code.toLowerCase()}.svg`}
    />
)

export default FlagIcon
